import s from "styled-components";

export const Attention = s.p`
  margin-top: 10px;
  max-width: 320px;
  line-height: 15px;
  font-size: 12px;
  font-weight: 500;
  margin-left: auto;
  margin-right: auto;
  color: var(--font-color-main);
`;
export const Politics = s.a`
  font-weight: 600;
  color: var(--color-cta);
  transition: opacity .35s ease;
  :hover {
    opacity: .7;
  }
`;
